// extracted by mini-css-extract-plugin
export default {"button":"styles_button__i-yXV","active":"styles_active__hfZXs","separator":"styles_separator__e9aw0"};